<script>
import store from '@state/store'
import ButtonAction from '@components/button-action'
import Title from '@components/section-title'
import FeedbackWrapper from '@modules/global/components/feedback-wrapper/feedback-wrapper.vue'
import {
  toPercent,
  getNumber,
  toMoney,
  toTitleCase,
  getUnique,
  formatNumber,
  possivelJSON,
  getRandomColor,
} from '@utils/Format'
import ModalPesquisaHistorico from '@modal/simulador-pesquisa-historico'
import ModalTrocar from '@modal/trocar-ativo'
import ModalAmpliarTabela from '@modal/simulador-ampliar-tabela'
import ModalRestricoes from '@modal/simulador-modal-restricoes'
import { GlobalBus } from '@services/bus'
import moment from 'moment'
import '@utils/moment_locale'
import {
  MODAL,
  BLACK_LIST_CALCULO_RENTABILIDADE,
  RELOAD,
  LINK_TUTORIALS,
  simuladorRoutes,
} from '@constants/Text'
import { simulador, minhaCarteira, pdf } from '@constants/URL'
import { funcaoIndisponivel } from '@utils/Whitelabel'
import { hasIncompleteAssets } from '@modules/consolidator/utils/HasIncompleteAssets/HasIncompleteAssets'
import LoadingStatus from '@components/loading-status'
import ShowLiquidez from '@components/show-liquidez-readonly'
import con from '@services/connection'
import Vue from 'vue'
import Cores from '@constants/Color'
import { apiSettingsBenchmarks } from '@modules/settings/api/apiSettingsBenchmarks'
import { apiConsolidatorSimulatorResult } from '@modules/consolidator/api/apiConsolidatorSimulatorResult.js'
import SimulatorPortfolioTable from '@modules/portfolio-review/components/simulator-portfolio-table/simulator-portfolio-table.vue'
import SimulatorOperationsTable from '@modules/portfolio-review/components/simulator-operations-table/simulator-operations-table.vue'
import ModalPortfolioReviewEditNotes from '@modules/portfolio-review/modal/edit-notes/portfolio-review-edit-notes.vue'
import ConditionalTeleport from '@components/teleport/conditional-teleport.vue'
import { aawzDate } from '@utils/dates/aawz-date'

export default {
  page: {
    title: 'Comparativo de simulações',
    meta: [{ name: 'description', content: 'ComparativoSimulacoes' }],
  },
  components: {
    Title,
    ButtonAction,
    FeedbackWrapper,
    ModalPesquisaHistorico,
    LoadingStatus,
    ModalTrocar,
    ModalAmpliarTabela,
    ModalRestricoes,
    ShowLiquidez,
    SimulatorPortfolioTable,
    SimulatorOperationsTable,
    ModalPortfolioReviewEditNotes,
    ConditionalTeleport,
  },
  props: {
    bus: {
      type: Object,
      default: null,
    },
    clienteModal: {
      type: Object,
      default: null,
    },
    hashSimulacaoModal: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      benchmarks_selecionados: [],
      benchmarks_selecionados_grafico: [],
      benchmarks_line: {},
      busModal: new Vue(),
      SHOW_WORKSPACE: SHOW_WORKSPACE,
      loading: false,
      loadingPDF: false,
      loadingCliente: false,
      simulando: false,
      headerCarteiraSimples: [
        {
          text: 'Ativo',
          align: 'left',
          value: 'nome_ativo',
        },
        {
          text: 'P/L Atual',
          value: 'aplicacao',
          width: 150,
        },
      ],
      headerCarteiraSimulada: [
        {
          text: 'Ativo',
          align: 'left',
          value: 'nome_ativo',
        },
        {
          text: 'P/L Simulado',
          value: 'aplicacao',
          width: 150,
        },
        {
          text: 'Comentário',
          value: 'comentario',
          width: 100,
        },
        {
          text: 'Tags',
          value: 'tags',
          width: 200,
        },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110,
        },
      ],
      headerCarteiraCompleta: [
        {
          text: 'Ativo',
          align: 'left',
          value: 'nome_ativo',
        },
        {
          text: 'P/L Atual',
          value: 'pl_atual',
          width: 150,
        },
        {
          text: 'Movimentação',
          value: 'movimentacao',
          width: 150,
        },
        {
          text: 'P/L Simulado',
          value: 'pl_final',
          width: 150,
        },
        {
          text: 'Comentário',
          value: 'comentario',
          width: 220,
        },
        {
          text: 'Tags',
          value: 'tags',
          width: 220,
        },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 30,
        },
      ],
      headerCarteiraOperacoes: [
        {
          text: 'Ativo',
          align: 'left',
          value: 'nome_ativo',
          width: 500,
        },
        {
          text: 'Operação',
          value: 'operacao',
        },
        {
          text: 'P/L movimentado',
          value: 'movimentacao',
          width: 150,
        },
        {
          text: 'Comentário',
          value: 'comentario',
          width: 220,
        },
        {
          text: 'Tags',
          value: 'tags',
          width: 220,
        },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 30,
        },
      ],
      lineChartDireita: {
        labels: ['1', '2', '3', '4'],
        datasets: [
          {
            label: 'Consolidado',
            fill: false,
            borderColor: '#56AF79',
            backgroundColor: '#56AF79',
            borderWidth: 5,
            data: [],
          },
          // {
          //   label: 'Benchmark',
          //   fill: false,
          //   stepped: true,
          //   borderWidth: 5,
          //   borderColor: '#2D212F',
          //   backgroundColor: '#2D212F',
          //   data: [],
          //   line: {
          //     borderDash: [0, 10],
          //     borderCapStyle: 'round',
          //   },
          // },
        ],
      },
      lineDataEsquerda: {
        labels: [],
        datasets: [],
      },
      lineOptions: {
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: (item, data) => {
              let label = data.datasets[item.datasetIndex].label || ''
              label += ': ' + toPercent(item.yLabel * 100)
              return label
            },
          },
        },
        hover: {
          mode: 'index',
          intersect: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontSize: 10,
                callback: (v, i, vs) => {
                  return toPercent(v * 100)
                },
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          point: {
            radius: 0,
            borderWidth: 0,
            style: 'star',
          },
          line: {
            borderWidth: 0,
          },
        },
        legend: {
          position: 'bottom',
        },
      },
      compEsquerda: {},
      compDireita: {},
      restricoes_simulacao: {},
      simulationError: '',
      simulationErrorMessage:
        'Não foi possível gerar a carteira. Revise as restrições e simule novamente.',
      modo: 'classe',
      simulacaoDireita: {
        nome_simulacao: 'Simulação',
        hash: '', // '285a34db-ade2-4803-995a-9d23c92e086e',
        id_cliente: 0, // 5993,
        load: 0,
        status: 'Iniciando...',
      },
      simulacaoEsquerda: {
        nome_simulacao: 'Simulação',
        hash: '',
        id_cliente: 0,
        load: 0,
        status: 'Iniciando...',
      },
      pl_esquerda: 0,
      pl_direita: 0,
      operacoes: [],
      messages: [],
      ativosDireita: [],
      backtestDireita: {},
      estatisticaDireita: {},
      estatisticaEsquerda: {},
      ativosEsquerda: [],
      novosAtivos: [],
      historico_simulacoes: [],
      has_changes: false,
      liquidezEsquerda: [],
      liquidezDireita: [],
      benchmark_graph_changed: false,
    }
  },
  computed: {
    moduleRoutes() {
      return simuladorRoutes()
    },
    alertMessages() {
      return (this.messages || [])
        .map((m) => (m || '').replaceAll(/(?:\s|<br\s*\/?>)+$/gi, '').trim())
        .filter(Boolean)
    },
    BENCHMARKS() {
      return this.$store.getters['settings/benchmarks']
    },
    clienteAtual() {
      return this.clienteModal || store.getters['user/currentClient'] || {}
    },
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
    historico() {
      return this.historico_simulacoes
        .filter((s) => {
          return s.nome_simulacao != this.simulacaoDireita.nome_simulacao
        })
        .reverse()
    },
    Color() {
      return store.getters['parameters/colors'] || {}
    },
    Paleta() {
      return store.getters['parameters/paleta'] || {}
    },
    lineDataDireita() {
      if (this.backtestDireita.portfolio) {
        const aux = { ...this.lineChartDireita }
        aux.labels = this.backtestDireita.portfolio['data']
        if (aux.datasets[0]) {
          aux.datasets[0].borderColor = this.Color.primary
          aux.datasets[0].backgroundColor = this.Color.primary
          aux.datasets[0].data = this.backtestDireita.portfolio['rent']
        }

        const benchs = []
        this.benchmarks_selecionados_grafico.forEach((key) => {
          benchs.push(this.benchmarks_line[key])
        })

        return { ...aux, datasets: [...aux.datasets, ...benchs] }
      } else {
        return this.lineChartDireita
      }
    },
    compEstr() {
      const aux = {}
      let cont = 0
      Object.entries(this.compDireita).forEach((a) => {
        aux[a[0]] = {
          name: a[0],
          color: this.Paleta[cont++],
          direita: (a[1] / this.pl_direita) * 100,
          esquerda: 0,
        }
      })
      Object.entries(this.compEsquerda).forEach((a) => {
        if (aux[a[0]]) {
          aux[a[0]].esquerda = (a[1] / this.pl_esquerda) * 100
        } else {
          aux[a[0]] = {
            name: a[0],
            color: this.Paleta[cont++],
            direita: 0,
            esquerda: (a[1] / this.pl_esquerda) * 100,
          }
        }
      })

      return aux
    },
    headerMenuActions() {
      const actions = [{ key: 'tutorial', label: 'Tutorial', icon: 'video' }]
      if (this.simulacaoDireita.hash_code) {
        actions.push({
          key: 'ver-restricoes',
          label: 'Ver restrições',
          icon: 'mdi-eye-outline',
        })
      }
      return actions
    },
    cardMenuActions() {
      const actions = [
        {
          key: 'simular-novamente',
          label: 'Simular novamente',
          icon: 'mdi-play-circle-outline',
        },
      ]
      if (this.simulacaoDireita.hash_code) {
        actions.push({
          key: 'ver-restricoes',
          label: 'Ver restrições',
          icon: 'mdi-eye-outline',
        })
      }
      if (this.restricoes_simulacao.tipo_simulador) {
        actions.push({
          key: 'alterar-restricoes',
          label: 'Alterar restrições',
          icon: 'mdi-tune-variant',
        })
      }
      return actions
    },
    totalAportes() {
      return this.sumPL(
        this.operacoes.filter((a) => {
          return a.operacao === 'C'
        }),
        'movimentacao'
      )
    },
    totalResgates() {
      return this.sumPL(
        this.operacoes.filter((a) => {
          return a.operacao === 'V'
        }),
        'movimentacao'
      ).replace('-', '')
    },
  },
  created() {
    this.busModal.$on('search_simulacao', this.reload)
    this.busModal.$on('changed_asset', this.ativoTrocado)

    if (this.hashSimulacaoModal && this.clienteModal) {
      // Caso esteja apresentando o resultado em um modal.
      this.simulacaoDireita.hash_code = this.hashSimulacaoModal
      this.simulacaoDireita.id_cliente = this.clienteModal.id
      this.loadSimulation()
    } else {
      if (
        this.$route.params.hash_code &&
        this.$route.params.hash_code != 'undefined'
      ) {
        // Caso receba os atributos da simulacao para apresentar
        this.simulacaoDireita.hash_code = this.$route.params.hash_code
        this.simulacaoDireita.id_cliente = this.$route.params.id_cliente
        this.simulacaoDireita.nome_simulacao =
          this.$route.params.nome_simulacao || 'Simulação'
        this.loadSimulation()
      }
      if (this.$route.params.simulacao) {
        // Caso recebe o objeto da simulacao para apresentar
        this.simulacaoDireita = this.$route.params.simulacao
        this.loadSimulation()
      }
      if (!this.$route.params.hash_code && !this.$route.params.simulacao) {
        // Caso nao receba nenhuma simulacao para apresentar, carrega os dados da ultima aberta.
        this._getLastSimulation()
      }
    }

    GlobalBus.$on('changeClient', this._getLastSimulation)
    GlobalBus.$on(MODAL.OPEN_SEND_COMPONENT, this.openSendComponent)
  },
  beforeDestroy() {
    GlobalBus.$off('changeClient', this._getLastSimulation)
    GlobalBus.$off(MODAL.OPEN_SEND_COMPONENT, this.openSendComponent)
  },
  methods: {
    showVideos() {
      const item = LINK_TUTORIALS[this.$route.name]
      if (!item || !item.url) {
        this.$showSnack({ text: 'Tutorial indisponível', button: true })
        return
      }
      GlobalBus.$emit(MODAL.SHOW_VIDEOS, { list: [item] })
    },
    clear() {
      this.compEsquerda = {}
      this.compDireita = {}
      this.restricoes_simulacao = {}
      this.simulationError = ''
      this.simulacaoDireita = {
        nome_simulacao: 'Simulação',
        hash: '', // '285a34db-ade2-4803-995a-9d23c92e086e',
        id_cliente: 0, // 5993,
        load: 0,
        status: 'Iniciando...',
      }
      this.simulacaoEsquerda = {
        nome_simulacao: 'Simulação',
        hash: '',
        id_cliente: 0,
        load: 0,
        status: 'Iniciando...',
      }
      this.pl_esquerda = 0
      this.pl_direita = 0
      this.operacoes = []
      this.messages = []
      this.ativosDireita = []
      this.backtestDireita = {}
      this.estatisticaDireita = {}
      this.estatisticaEsquerda = {}
      this.ativosEsquerda = []
      this.novosAtivos = []
      this.historico_simulacoes = []
      this.has_changes = false
      this.liquidezEsquerda = []
      this.liquidezDireita = []

      this.benchmark_graph_changed = false

      this.loadingPDF = false
      this.loadingCliente = false
      this.simulando = false

      this.lineChartDireita = {
        labels: ['1', '2', '3', '4'],
        datasets: [
          {
            label: 'Consolidado',
            fill: false,
            borderColor: '#56AF79',
            backgroundColor: '#56AF79',
            borderWidth: 5,
            data: [],
          },
          {
            label: 'CDI',
            fill: false,
            stepped: true,
            borderWidth: 3,
            borderColor: '#2D212F',
            backgroundColor: '#2D212F',
            data: [],
            line: {
              borderDash: [0, 10],
              borderCapStyle: 'round',
            },
          },
        ],
      }
      this.lineDataEsquerda = {
        labels: [],
        datasets: [],
      }
    },
    normalizeTags(rawTags) {
      if (Array.isArray(rawTags)) {
        return rawTags
      }

      if (!rawTags) {
        return []
      }

      if (typeof rawTags === 'string') {
        const trimmed = rawTags.trim()

        if (!trimmed) {
          return []
        }

        const parsed = possivelJSON(trimmed)
        if (Array.isArray(parsed)) {
          return parsed
        }

        if (trimmed[0] === '[' && trimmed[trimmed.length - 1] === ']') {
          const inner = trimmed.slice(1, -1)
          const parts = inner.split(',')
          const tags = parts
            .map((tag) => tag.replace(/^['"\s]+|['"\s]+$/g, ''))
            .filter((tag) => tag)

          if (tags.length) {
            return tags
          }
        }

        return [trimmed]
      }

      return []
    },
    _enrichOperationsFromAssets(posicao) {
      const ativos = this['ativos' + toTitleCase(posicao)] || []
      const assetMap = {}
      ativos.forEach(function (a) {
        assetMap[a.nome_ativo] = a
      })
      this.operacoes = this.operacoes.map(function (op) {
        const asset = assetMap[op.nome_ativo]
        if (!asset) return op
        return Object.assign({}, op, {
          recomendacao: op.recomendacao || asset.recomendacao || '',
          setor: op.setor || asset.setor || '',
          comentario: op.comentario || asset.comentario || '',
          tags:
            op.tags && op.tags.length > 0 ? op.tags : asset.tags || [],
        })
      })
    },
    updateLocalNotes({ nomeAtivo, comentario, tags }) {
      const applyUpdate = (list) =>
        Array.isArray(list)
          ? list.map((item) => {
              if (!item || item.nome_ativo !== nomeAtivo) {
                return item
              }

              return {
                ...item,
                comentario: comentario || '',
                tags: Array.isArray(tags) ? [...tags] : [],
              }
            })
          : list

      this.ativosDireita = applyUpdate(this.ativosDireita)
      this.operacoes = applyUpdate(this.operacoes)
    },
    async handleSaveNotes({ asset, comentario, tags }) {
      if (!asset) {
        return
      }

      const clientId =
        this.simulacaoDireita.id_cliente_app || this.simulacaoDireita.id_cliente

      const cleanTags = Array.isArray(tags)
        ? tags
            .map((tag) => (tag == null ? '' : String(tag).trim()))
            .filter((tag) => tag)
        : []

      const payload = {
        clientId,
        simulationHash: this.simulacaoDireita.hash_code,
        nomeAtivo: asset.nome_ativo,
        comentario: comentario || '',
        tags: cleanTags,
      }

      const r = await apiConsolidatorSimulatorResult.updateSuggestedAsset(
        payload
      )

      if (r && r.status === 200) {
        this.updateLocalNotes({
          nomeAtivo: asset.nome_ativo,
          comentario: comentario || '',
          tags: cleanTags,
        })

        this.$showSnack({
          text: 'Comentário e tags atualizados com sucesso.',
          button: true,
        })
      } else {
        this.$showSnack({
          text:
            (r && r.message) ||
            'Não foi possível atualizar o comentário e as tags.',
          button: true,
        })
      }
    },
    abrirModal() {
      setTimeout(() => {
        this.$refs.rentabilidade2.$forceUpdate()
      }, 300)
    },
    openSendComponent() {
      GlobalBus.$emit(
        MODAL.WORKSPACE_SEND_COMPONENT,
        {
          page: this.$route.name,
          data: {
            id_cliente: this.$currentClient().id,
            hash_simulacao: this.simulacaoDireita.hash_code,
          },
        },
        this.$currentClient()
      )
    },
    getDistanceDate(d) {
      return moment(d, 'DD/MM/YYYY').fromNow()
    },
    toPercent(d) {
      return toPercent(d)
    },
    formatNumber(d) {
      return formatNumber(d)
    },
    toMoney(d) {
      return toMoney(d)
    },
    async loadSimulation() {
      this.simulationError = ''
      const sim = this.simulacaoDireita.hash_code
      const id =
        this.simulacaoDireita.id_cliente_app || this.simulacaoDireita.id_cliente
      if (sim && sim != 'undefined') {
        this.loading = true
      } else {
        return
      }
      await this._getRestricoes(sim)
      this._checkMessages(sim)

      // Direita
      this._loadBacktest(sim, id)
      this._getName()
      this._loadBacktestBenchmarks(sim, id)
      await this._loadData(sim, id) // posicao

      // Esquerda
      if (this.simulacaoEsquerda.hash) {
        this._loadData(
          this.simulacaoEsquerda.hash,
          this.simulacaoEsquerda.id_cliente,
          'esquerda'
        )
        this._loadBacktest(
          this.simulacaoEsquerda.hash,
          this.simulacaoEsquerda.id_cliente,
          'esquerda'
        )
      } else {
        this.setCarteira(id) // Carteira atual
        this.setEvolucao(id) // Evolucao atual
        this.loadFracoesAtual(id) // Liquidez atual
      }

      this._saveLastSimulation()
    },
    _getLastSimulation() {
      const sim = window.localStorage.getItem(
        `19d489c-${this.usuarioAtual.id_interno}-${this.clienteAtual.id}698dc`
      )
      if (sim && sim != 'undefined') {
        this.simulacaoDireita.hash_code = sim
        this.simulacaoDireita.id_cliente = this.clienteAtual.id
        this.loadSimulation()
      } else {
        this.clear()
      }
    },
    _saveLastSimulation() {
      if (
        this.usuarioAtual.id_interno &&
        this.clienteAtual.id &&
        this.simulacaoDireita.hash_code
      ) {
        window.localStorage.setItem(
          `19d489c-${this.usuarioAtual.id_interno}-${this.clienteAtual.id}698dc`,
          this.simulacaoDireita.hash_code
        )
      }
    },
    async _getRestricoes(sim) {
      if (sim) {
        const r = await con.get(
          simulador.manage + sim + '?attributes=restricoes_simulacao'
        )
        if (r.status === 200) {
          this.restricoes_simulacao = possivelJSON(r.value.restricoes_simulacao)
          this.modo = this.restricoes_simulacao.modo_simulador || 'classe'
        }
      }
    },
    async _checkMessages(sim) {
      if (!sim) {
        return
      }
      const r = await con.get(
        simulador.manage +
          this.simulacaoDireita.hash_code +
          '?attributes=resultado_simulacao'
      )
      if (r.status === 200) {
        this.messages = []
        if (r.value.resultado_simulacao && r.value.resultado_simulacao.alerta) {
          this.messages = [
            ...this.messages,
            ...r.value.resultado_simulacao.mensagem_alerta,
          ]
        }
        if (r.value.resultado_simulacao && r.value.resultado_simulacao.caixa) {
          this.messages = [
            ...this.messages,
            ...r.value.resultado_simulacao.caixa_message,
          ]
        }
      } else {
        this.messages = []
      }
    },
    async _getName() {
      if (!this.simulacaoDireita.hash_code) {
        return
      }
      const r = await con.get(
        simulador.manage +
          this.simulacaoDireita.hash_code +
          '?attributes=nome_simulacao,simulacao_salva' // expire_date
      )
      if (r.status === 200) {
        this.simulacaoDireita.nome_simulacao = r.value.nome_simulacao
        this.simulacaoDireita.simulacao_salva = r.value.simulacao_salva
      } else {
        this.simulacaoDireita.nome_simulacao = 'Simulação'
        this.simulacaoDireita.simulacao_salva = false
        this.simulacaoDireita.expire_date = ''
      }
    },
    async _loadData(sim, id, posicao = 'direita') {
      if (!sim || !id) {
        return
      }

      const r = await apiConsolidatorSimulatorResult.loadResult({
        clientId: id,
        simulationHash: sim,
        forceUpdate: true,
      })

      if (r.status === 200) {
        if (r.value.simulation_status === 200) {
          this[`estatistica${toTitleCase(posicao)}`] = r.value.statistics
          this[`pl_${posicao}`] = r.value.statistics.pl

          if (posicao === 'direita') {
            this.operacoes = (r.value.operations || []).map((item) => {
              if (!item.subclasse) {
                item.subclasse = item.classe
              }

              item.comentario =
                typeof item.comentario === 'string' ? item.comentario : ''
              item.tags = this.normalizeTags(item.tags)

              return item
            })
          }

          this[`ativos${toTitleCase(posicao)}`] = (r.value.assets || []).map(
            (a) => {
              a.comentario =
                typeof a.comentario === 'string' ? a.comentario : ''
              a.tags = this.normalizeTags(a.tags)
              return a
            }
          )

          if (posicao === 'direita') {
            this._enrichOperationsFromAssets(posicao)
          }

          const aux = {}
          if (r.value.assets) {
            r.value.assets.forEach((a) => {
              aux[a[this.modo]] = (aux[a[this.modo]] || 0) + a['Aplicação']
            })
          }
          this[`comp${toTitleCase(posicao)}`] = aux
        } else {
          this.simulationError = this.simulationErrorMessage
        }
      } else {
        this[`estatistica${toTitleCase(posicao)}`] = {}
        this[`pl_${posicao}`] = 0
        this.operacoes = []
        this[`ativos${toTitleCase(posicao)}`] = []
        this[`comp${toTitleCase(posicao)}`] = {}
      }
    },
    /**
     * Carregar dados para as rentabilidades dos benchmarks no grafico da simulacao
     */
    async _loadBacktestBenchmarks(sim, id) {
      if (!sim || !id) {
        return
      }
      const partes = ['simulation_backtest', 'graph_liquidity']
      const r = await con.get(
        `${
          simulador.analise
        }${id}?simulation_hash_code=${sim}&report_parts=${partes.join(',')}`
      )

      if (r && r.status === 200) {
        this.benchmarks_line = await this.setLineBenchmarks(
          r.value.simulation_backtest['benchmarks-returns']
        )
        this.backtestDireita = {
          portfolio: {
            data: r.value.simulation_backtest.index,
            rent: r.value.simulation_backtest['portfolio-simulation'],
            start: r.value.simulation_backtest.begin,
            end: r.value.simulation_backtest.end,
          },
        }

        this.liquidezDireita = r.value.graph_liquidity
      } else {
        this.benchmarks_line = []
        this.liquidezDireita = []
      }

      this.loading = false
    },
    async setLineBenchmarks(value) {
      await apiSettingsBenchmarks.carregar()
      const graphBenchmark = value || {}
      const benchs = this.$store.getters['settings/benchmarks']
      const cdi = benchs.find((b) => b.nome === 'CDI')
      if (cdi) {
        this.benchmarks_selecionados_grafico.push(cdi.id)
      }

      return benchs.reduce((all, bench) => {
        const color = Cores.BENCHMARKS_COLORS[bench.nome] || getRandomColor()
        all[bench.id] = {
          label: bench.nome,
          data: graphBenchmark[bench.id] || [],
          borderColor: color,
          backgroundColor: color,
          fill: false,
          stepped: true,
          pointRadius: 0,
          borderWidth: 3,
          line: {
            borderDash: [0, 10],
            borderCapStyle: 'round',
          },
        }
        all[bench.nome] = all[bench.id]
        return all
      }, {})
    },
    async _loadBacktest(sim, id, posicao = 'direita') {
      if (!sim || !id) {
        return
      }
      const data = {
        id_cliente: id,
        simulation_hash_code: sim,
      }
      const r = await con.post(simulador.sim_backtest, data)
      if (r.status === 200) {
        this[`backtest${toTitleCase(posicao)}`] = r.value
        if (posicao == 'esquerda') {
          const aux = { ...this.lineChartDireita }
          aux.labels = r.value.portfolio['data']
          if (aux.datasets[1]) {
            aux.datasets[0].borderColor = this.Color.primary
            aux.datasets[0].backgroundColor = this.Color.primary
            aux.datasets[0].data =
              r.value.portfolio['rentabilidade_acumulada'] ||
              r.value.portfolio['rentabiliade_acumulada']
            aux.datasets[1].data =
              r.value.benchmark['rentabilidade_acumulada'] ||
              r.value.benchmark['rentabiliade_acumulada']
          }

          this.lineDataEsquerda = aux
        }
      } else {
        this[`backtest${toTitleCase(posicao)}`] = {}
      }
    },
    async _loadOperacoes(sim, id) {
      if (!sim || !id) {
        return
      }
      const data = {
        id_cliente: id,
        simulation_hash_code: sim,
      }
      const r = await con.post(simulador.sim_operacoes, data)
      if (r.status === 200) {
        this.operacoes = r.value
      } else {
        this.operacoes = []
      }
    },
    async _loadAtivos(sim, id, posicao = 'direita') {
      if (!sim || !id) {
        return
      }
      const data = {
        id_cliente: id,
        simulation_hash_code: sim,
      }
      const r = await con.post(simulador.sim_ativos, data)
      if (r.status === 200) {
        this[`ativos${toTitleCase(posicao)}`] = r.value || []
      } else {
        this[`ativos${toTitleCase(posicao)}`] = []
      }
    },
    async setEvolucao(id) {
      if (!id) {
        return
      }
      const data = {
        id_cliente: id,
      }
      let r = await con.post(minhaCarteira.rentabilidade, data)
      if (r.status === 200) {
        this.estatisticaEsquerda = r.value.dados.find((r) => {
          return r.legend === 'Todos'
        }).summary
        this.lineDataEsquerda = {
          labels: r.value.data_competencia || [],
          datasets: [
            {
              label: 'Consolidado',
              fill: false,
              borderColor: this.Color.primary,
              backgroundColor: this.Color.primary,
              borderWidth: 5,
              data:
                r.value.dados.find((r) => {
                  return r.legend === 'Todos'
                }).values || [],
            },
            {
              label: 'CDI',
              fill: false,
              stepped: true,
              borderWidth: 3,
              borderColor: '#2D212F',
              backgroundColor: '#2D212F',
              data: r.value.benchmark.CDI || [],
              line: {
                borderDash: [0, 10],
                borderCapStyle: 'round',
              },
            },
          ],
        }
      } else {
        this.lineDataEsquerda = {
          labels: [],
          datasets: [],
        }
        this.estatisticaEsquerda = {}
      }
    },
    async setCarteira(id) {
      if (!id) {
        return
      }
      const data = {
        id_cliente: id,
      }
      let r = await con.post(minhaCarteira.posicao, data)
      if (Object.keys(r).length) {
        const aux = []
        Object.keys(r).forEach((v) => {
          this.pl_esquerda += getNumber(r[v]['Aplicação'])
          aux.push(JSON.parse(r[v].ativos))
        })
        const comp = {}
        const attr_group = this.modo === 'classe' ? 'CI' : this.modo
        this.ativosEsquerda = aux.flat().map((a) => {
          if (!a.subclasse && this.modo === 'subclasse') {
            const asset = this.ativosDireita.find((item) => {
              return item.nome_ativo === a.nome_ativo
            })
            if (asset) {
              a.subclasse = asset.subclasse
            } else {
              a.subclasse = a['CI']
            }
          }

          comp[a[attr_group]] = (comp[a[attr_group]] || 0) + a['Aplicação']
          return {
            Aplicação: a['Aplicação'],
            aplicacao: a['Aplicação_f'],
            classe: a['CI'],
            subclasse: a.subclasse || a['CI'],
            id_ativo: a.id,
            nome_ativo: a['Ativo + Taxa'],
            percent: a.final_formatado,
          }
        })
        this.compEsquerda = comp
      } else {
        this.ativosEsquerda = []
        this.compEsquerda = {}
      }
      this.setIncompleteAssets(r)
    },
    async loadFracoesAtual(id) {
      const data = {
        id_cliente: id,
      }
      const r = await con.post(minhaCarteira.composicao, data)
      if (r && r.status === 200) {
        this.liquidezEsquerda = r.value.liquidez
      } else {
        this.liquidezEsquerda = []
      }
    },
    setIncompleteAssets(r) {
      if (!this.usuarioAtual.IS_CLIENTE) {
        const has_incomplete = hasIncompleteAssets(
          r,
          BLACK_LIST_CALCULO_RENTABILIDADE
        )

        this.$store.dispatch('user/setClientInfo', {
          has_incompletes_assets: has_incomplete,
        })
      }

      this.$store.dispatch('user/checkIncompleteAsset')
    },
    entendaMaisEstatistica() {
      this.$showModal({
        title: 'Estatística',
        subtitle: 'Carteira simulada',
        text: `As estatísticas da simulação são realizadas considerando as boas práticas de mercado e gestão de portfólio. Utilizamos lógicas de precificação considerando a curva DI para renda fixa e o desvio padrão dos retornos para fundos de investimentos.
\n\n
\n
No gráfico você consegue verificar a rentabilidade acumulada, dia-a-dia, e na tabela logo abaixo você tem as estatísticas anualizadas dessa carteira.`,
        buttons: [
          {
            text: 'Ok',
            action: null,
            class: { primary: true },
          },
        ],
      })
    },
    sumPL(items, attr = 'Aplicação') {
      return toMoney(
        items.reduce((a, b) => {
          return a + getNumber(b[attr])
        }, 0)
      )
    },
    openSearchHistory() {
      GlobalBus.$emit(MODAL.SIMULATOR_SEARCH_HISTORY, true)
    },
    openRestricoes() {
      GlobalBus.$emit(MODAL.VER_RESTRICOES, {
        ...this.simulacaoDireita,
        modo_simulador: this.modo,
      })
    },
    onHeaderAction(item) {
      const key = item && item.key
      if (key === 'tutorial') {
        this.showVideos()
      } else if (key === 'ver-restricoes') {
        this.openRestricoes()
      }
    },
    onCardAction(item) {
      const key = item && item.key
      if (key === 'simular-novamente') {
        this.simulateAgain()
      } else if (key === 'ver-restricoes') {
        this.openRestricoes()
      } else if (key === 'alterar-restricoes') {
        this.toRestricoes()
      }
    },
    openEditNome() {
      const span = this.$refs.nomeSpan
      if (span && typeof span.click === 'function') {
        span.click()
      }
    },
    reload(simulacao) {
      if (this.loading) {
        return
      }
      if (simulacao) {
        this.loading = true
        this.simulacaoDireita = simulacao
        this.historico_simulacoes = [
          ...new Set([...this.historico_simulacoes, simulacao]),
        ]
        this.loadSimulation()
      }
    },
    async salvarNomeSimulacao() {
      if (!this.simulacaoDireita.hash_code) {
        this.$showSnack({
          text: 'Nenhuma simulação selecionada',
          button: true,
        })
      }
      const data = {
        id_cliente_app: this.simulacaoDireita.id_cliente_app,
        dados: JSON.stringify({
          nome_simulacao: this.simulacaoDireita.nome_simulacao,
          simulacao_salva: true,
        }),
      }
      const r = await con.put(
        simulador.manage + this.simulacaoDireita.hash_code,
        data
      )

      if (r.status === 200) {
        GlobalBus.$emit(RELOAD.SIM_RUNNING)
      }

      this.$showSnack({
        text: r.message,
        button: true,
      })
    },
    async toPermanent() {
      if (this.simulacaoDireita.simulacao_salva) {
        return
      }
      const data = {
        id_cliente_app: this.simulacaoDireita.id_cliente_app,
        dados: JSON.stringify({
          simulacao_salva: true,
        }),
      }
      const r = await con.put(
        simulador.manage + this.simulacaoDireita.hash_code,
        data
      )
      if (r.status === 200) {
        this.loadSimulation()
      }
      this.$showSnack({
        text: r.message,
        button: true,
      })
    },
    async simulateAgain() {
      this.simulationError = ''
      const r = await con.get(
        simulador.manage +
          this.simulacaoDireita.hash_code +
          '?attributes=restricoes_simulacao,id_cliente_app'
      )
      const restr = r.value.restricoes_simulacao
      if (restr.ativos_fixos) {
        let ativos = possivelJSON(restr.ativos_fixos)
        ativos = getUnique([...ativos, ...this.novosAtivos], 'nome_ativo')
        restr.ativos_fixos = ativos.map((a) => {
          a.pl = getNumber(a.pl)
          return a
        })
      } else {
        restr.ativos_fixos = this.novosAtivos
      }

      if (restr && restr.ativo_fixos) {
        delete restr['ativo_fixos']
      }

      const data = {
        id_cliente_app: r.value.id_cliente_app,
        id_cliente_web: this.clienteAtual.id_cadastro_cliente || null,
        simulacao: JSON.stringify(restr),
      }
      this.simulacaoDireita.id_cliente_app = r.value.id_cliente_app
      this.enviarSimular(data)
    },
    moreInfo(ativos, opts) {
      GlobalBus.$emit(MODAL.SIMULATOR_MORE_INFO, ativos, opts)
    },
    async enviarSimular(data) {
      if (!this.$currentClient().name) {
        this.$showSnack({
          text: 'Selecione um cliente para simular',
          button: true,
        })
        return
      }

      const r = await con.post(simulador.run, data)
      this.simulando = true
      this.simulacaoDireita = {
        ...this.simulacaoDireita,
        hash_code: r.value.simulation_hash_code,
        status: 'Enviando requisição',
        load: 0,
      }
      if (r.status === 200) {
        store.dispatch('simulador/addRunning', {
          ...this.simulacaoDireita,
          hash_code: r.value.simulation_hash_code,
          status_simulacao: '100',
          data_simulacao: aawzDate().format('DD/MM/YYYY HH:mm'),
          id_cliente: data.id_cliente_web,
          id_cliente_app: data.id_cliente_app,
          id_profissional: this.$currentUser().id_interno,
          nome_cliente: this.clienteAtual.name,
        })
      } else {
        this.$showSnack({
          text: r.message,
          button: true,
        })
      }
      setTimeout(() => {
        this.checkStatusSimulation(r.value.simulation_hash_code)
      }, 10000)
    },
    async checkStatusSimulation(sim) {
      const data = {
        id_cliente: this.clienteAtual.id,
        id_cliente_app: this.clienteAtual.id,
        id_cliente_web: this.clienteAtual.id_cadastro_cliente || null,
        simulation_hash_code: sim || this.simulacaoDireita.hash_code,
      }
      const r = await con.post(simulador.status, data)
      if (r.value && r.value.step > 0) {
        const progress = (r.value.step / r.value.n_steps) * 100
        this.simulacaoDireita = {
          ...this.simulacaoDireita,
          hash_code: r.value.hash_code,
          status: r.value.details,
          load:
            progress > this.simulacaoDireita.load
              ? progress + 2
              : this.simulacaoDireita.load + 2,
        }
        store.dispatch('simulador/updateRunning', {
          ...this.simulation,
          status_simulacao: r.value.status === 'running' ? 100 : 200,
        })
        setTimeout(() => {
          this.checkStatusSimulation(sim)
        }, 6000)
      } else {
        if (r.status === 200) {
          this.simulacaoDireita.id_cliente = this.clienteAtual.id
          this.simulacaoDireita.status = 'Enviando requisição'
          this.simulacaoDireita.load = 0
          this.simulando = false
          this.reload(this.simulacaoDireita)
          store.dispatch('simulador/updateRunning', {
            ...this.simulation,
            load: 1,
            status_simulacao: r.value.status === 'running' ? 100 : 200,
          })
        } else {
          this.simulationError = this.simulationErrorMessage
          store.dispatch('simulador/updateRunning', {
            ...this.simulation,
            load: 1,
            status_simulacao: r.status,
          })
          this.simulando = false
        }
      }
    },
    async toRestricoes() {
      if (!this.restricoes_simulacao.ativos_fixos) {
        this.restricoes_simulacao.ativos_fixos = []
      }
      this.restricoes_simulacao.ativos_fixos = [
        ...this.restricoes_simulacao.ativos_fixos,
        ...this.novosAtivos,
      ]
      this.$router.push({
        name: `simulador.${this.restricoes_simulacao.tipo_simulador}`,
        params: {
          restricoes: this.restricoes_simulacao,
        },
      })
    },
    trocarAtivo(asset) {
      const old = this.novosAtivos.find((a) => {
        return asset.nome_ativo === a.nome_ativo
      })

      if (old) {
        this.$showSnack({
          text: 'Não é possível trocar este ativo',
          button: true,
        })
        return
      }

      this.busModal.$emit(MODAL.CHANGE_ASSET, asset)
    },
    ativoTrocado(asset) {
      const old = this.novosAtivos.find((a) => {
        return a.nome_ativo === asset.antigo.nome_ativo
      })
      const ativo = this.ativosDireita.find((a) => {
        return a.nome_ativo === asset.antigo.nome_ativo
      })
      if (old) {
        old.pl = getNumber(ativo['Aplicação']) - getNumber(asset.novo.pl)
        old.percent = '0,00%'
        delete old['Aplicação']
      } else {
        const aux = {
          ...asset.antigo,
          pl: getNumber(ativo['Aplicação']) - getNumber(asset.novo.pl),
        }
        delete aux['Aplicação']
        this.novosAtivos.push(aux)
      }
      const novo = {
        pl: getNumber(asset.novo.pl),
        nome_ativo: asset.novo.nome_ativo,
        classe: asset.novo.classe,
        tipo: asset.novo.tipo,
      }
      this.novosAtivos.push(novo)
      this.has_changes = true
      this.$showSnack({
        text: `Ativos trocados com sucesso`,
        button: true,
      })
    },
    bloquearAtivo(asset) {
      if (this.checkAssetInSimulation(asset)) {
        this.$showSnack({
          text: 'Não é possível bloquear este ativo.',
          button: true,
        })
      } else {
        delete asset['Aplicação']
        this.addAtivo({ ...asset, pl: 0 })
        this.has_changes = true
        this.$showSnack({
          text: `${asset.nome_ativo} bloqueado com sucesso`,
          button: true,
        })
      }
    },
    fixarAtivo(asset) {
      if (this.checkAssetInSimulation(asset)) {
        this.$showSnack({
          text: 'Não é possível fixar este ativo.',
          button: true,
        })
      } else {
        if (!asset.pl) {
          asset.pl =
            getNumber(asset.pl_atual) ||
            getNumber(asset.aplicacao) ||
            getNumber(asset['Aplicação'])
        }
        delete asset['Aplicação']
        this.addAtivo(asset)
        this.has_changes = true
        this.$showSnack({
          text: `${asset.nome_ativo} fixado com sucesso`,
          button: true,
        })
      }
    },
    addAtivo(ativo) {
      /**
       * id_ativo [na base]
       * classe
       * id_ativo_atual [null se não houver]
       * nome_ativo
       * pl
       * referencia
       *
       * modo
       * percentual
       */
      const index = this.novosAtivos.findIndex((a) => {
        return a.nome_ativo === ativo.nome_ativo
      })
      if (index >= 0) {
        this.$set(this.novosAtivos, index, ativo)
      } else {
        this.novosAtivos.push(ativo)
      }
      return index
    },
    checkAssetInSimulation(asset) {
      const existente = this.novosAtivos.find((a) => {
        return asset.nome_ativo === a.nome_ativo
      })
      return existente
    },
    async checkStatusPDF(hash, id_cliente, send_client = false) {
      const r = await con.get(pdf.simulacao.get + `${id_cliente}/${hash}`)
      if (r.status === 200 && r.step == -1) {
        if (send_client) {
          this.enviarParaCliente(hash)
          this.loadingCliente = false
        } else {
          this.baixarPDF(hash, id_cliente)
          this.loadingPDF = false
        }
      } else if (r.status === 200) {
        setTimeout(() => {
          this.checkStatusPDF(hash, id_cliente, send_client)
        }, 3000)
      } else {
        this.loadingPDF = false
        this.$showSnack({
          text: r.message,
          button: true,
        })
      }
    },
    baixarPDF(hash, id_cliente) {
      window.location.href =
        window.location.origin +
        pdf.simulacao.get +
        `${id_cliente}/${hash}?download=true`
    },
    async sendClient() {
      if (!this.$isWhitelabel()) {
        funcaoIndisponivel(this)
        return
      }

      this.openSelectModelPDF({ send_client: true })
    },
    enviarParaCliente(hash) {
      GlobalBus.$emit(MODAL.SEND_COMUNICATE, {
        clientes: this.clienteAtual,
        noticia: {
          titulo: 'Relatório - Análise Portfólio',
          descricao: 'Relatório .PDF com sua análise de portfólio',
          url: hash + '::simulation',
          tipo: 'pdf',
        },
        hideUrl: true,
        fixComunicado: true,
      })
    },
    openSelectModelPDF({ send_client = false } = {}) {
      const params = {
        corretora: 'Todas',
        // with_current_portfolio_comparison: true,
        // benchmarks_selection: JSON.stringify({
        //   simulation_and_current_portfolio_backtest: this
        //     .benchmarks_selecionados_grafico,
        // }),
      }

      const bench_selection = {}

      if (this.benchmark_graph_changed) {
        bench_selection.simulation_and_current_portfolio_backtest =
          this.benchmarks_selecionados_grafico
      }

      params.benchmarks_selection = JSON.stringify(bench_selection)

      GlobalBus.$emit(MODAL.SELECT_PDF_MODEL, 'simulador.comparativo', {
        hash: this.simulacaoDireita.hash_code,
        id_cliente: this.clienteAtual.id,
        params,
        modo_simulador: this.modo,
        send_client,
      })
    },
  },
}
</script>

<template>
  <section class="container-sm mt-6">
    <ConditionalTeleport
      v-if="!clienteModal"
      to="page-header-actions"
      :routes="moduleRoutes"
    >
      <BasePageHeader>
        <template v-slot:actions>
          <BaseSplitButton
            label="Selecionar outra simulação"
            :items="headerMenuActions"
            @click="openSearchHistory"
            @select="onHeaderAction"
          />
        </template>
      </BasePageHeader>
    </ConditionalTeleport>

    <FeedbackWrapper
      v-if="!clienteAtual.name"
      bordered
      :no-data="true"
      message="Selecione um cliente para simular"
      :min-height="360"
    />
    <div
      v-else-if="loading"
      class="row justify-content-center mt-n3 simulador-comparativo__skeleton"
      style="max-width: -webkit-fill-available"
    >
      <div class="col-12">
        <div class="az-card-bordered">
          <BaseLoadingSkeleton height="56px" />
        </div>
      </div>
      <div class="col-12">
        <div class="az-card-bordered">
          <BaseLoadingSkeleton height="220px" />
        </div>
      </div>
      <div class="col-4">
        <div class="az-card-bordered h-100">
          <BaseLoadingSkeleton height="180px" />
        </div>
      </div>
      <div class="col-4">
        <div class="az-card-bordered h-100">
          <BaseLoadingSkeleton height="180px" />
        </div>
      </div>
      <div class="col-4">
        <div class="az-card-bordered h-100">
          <BaseLoadingSkeleton height="180px" />
        </div>
      </div>
    </div>

    <FeedbackWrapper
      v-else-if="!simulacaoDireita.hash_code"
      bordered
      :no-data="true"
      message="Selecione uma simulação"
      :min-height="360"
    >
      <template v-slot:button>
        <BaseButton dark outline @click="openSearchHistory">
          Selecionar simulação
        </BaseButton>
      </template>
    </FeedbackWrapper>
    <div
      v-else
      class="row justify-content-center mt-n3"
      style="max-width: -webkit-fill-available"
    >
      <div class="col-12">
        <div
          class="az-card-bordered d-flex align-center"
          style="max-width: 100%"
        >
          <v-edit-dialog
            :return-value.sync="simulacaoDireita.nome_simulacao"
            large
            cancel-text="Cancelar"
            save-text="Salvar"
            @save="salvarNomeSimulacao"
          >
            <span
              ref="nomeSpan"
              class="az-ds-card-title simulador-comparativo__nome"
            >
              {{ simulacaoDireita.nome_simulacao }}
            </span>

            <template v-slot:input>
              <v-text-field
                v-model="simulacaoDireita.nome_simulacao"
                dense
                hide-details
                label="Simulação"
              ></v-text-field>
            </template>
          </v-edit-dialog>
          <v-spacer />
          <BaseSplitButton
            label="Editar nome"
            :items="cardMenuActions"
            @click="openEditNome"
            @select="onCardAction"
          />
        </div>
      </div>
      <div v-if="simulationError" class="col-12">
        <BaseAlert icon="warning" iconColor="warning">
          {{ simulationError }}
          <template v-slot:button>
            <BaseButton
              v-if="restricoes_simulacao.tipo_simulador"
              small
              dark
              outline
              min-width="80px"
              class="mx-10"
              @click="toRestricoes"
            >
              Alterar restrições
            </BaseButton>
          </template>
        </BaseAlert>
      </div>
      <div v-if="alertMessages.length" class="col-12">
        <BaseAlert icon="info" iconColor="info">
          <span v-for="m in alertMessages" :key="m" v-html="m"></span>
        </BaseAlert>
      </div>
      <div class="col-4">
        <div class="az-card-bordered h-100">
          <div class="d-flex mb-10">
            <h2 class="az-ds-card-title">
              {{
                simulacaoEsquerda.hash
                  ? simulacaoEsquerda.nome_simulacao
                  : 'Carteira atual'
              }}
            </h2>
            <v-spacer />
            <BaseModal
              max-width="80%"
              :destroy-on-close="true"
              height="600px"
              class="d-inline"
            >
              <template v-slot:button>
                <div class="d-flex align-center" @click="abrirModal">
                  <small class="az-text-small az-muted mr-1"> Ampliar </small>
                  <icon-svg name="mdi-fullscreen" :size="16" color="#8E8E8E" />
                </div>
              </template>
              <div>
                <Title title="Carteira atual" />
                <line-chart
                  ref="rentabilidade2"
                  :chart-data="lineDataEsquerda"
                  :options="lineOptions"
                  :styles="{ height: '80vh', width: '100%' }"
                >
                </line-chart>
              </div>
            </BaseModal>
          </div>
          <!-- Margem para compensar o "Visualizar benchmark" da parte da direita -->
          <div style="margin-bottom: 52px">
            <line-chart
              ref="rentabilidade"
              :chart-data="lineDataEsquerda"
              :options="lineOptions"
            >
            </line-chart>
          </div>
          <v-divider class="my-5" />
          <h2 class="az-text-primary az-size-14 font-semibold">
            Estatísticas anualizadas
          </h2>
          <div class="row">
            <div class="col-3">
              <small class="az-text-small">Rent.</small>
            </div>
            <div class="col-3 text-right">
              <small class="az-text-small font-bold">
                {{
                  toPercent(
                    (estatisticaEsquerda.retorno_anualizado ||
                      estatisticaEsquerda.rp_acumulado) * 100
                  )
                }}
              </small>
            </div>
            <div class="col-3">
              <small class="az-text-small">Rent. Rel.</small>
            </div>
            <div class="col-3 text-right">
              <small class="az-text-small font-bold">
                {{
                  toPercent(
                    (estatisticaEsquerda.retorno_anualizado_relativo ||
                      estatisticaEsquerda.coef_cdi) * 100
                  )
                }}
              </small>
            </div>
            <div class="col-3">
              <small class="az-text-small">Vol.</small>
            </div>
            <div class="col-3 text-right">
              <small class="az-text-small font-bold">
                {{ toPercent(estatisticaEsquerda.vol * 100) }}
              </small>
            </div>
            <div class="col-3">
              <small class="az-text-small">Sharpe</small>
            </div>
            <div class="col-3 text-right">
              <small class="az-text-small font-bold">
                {{ formatNumber(estatisticaEsquerda.sharp_ratio || 0) }}
              </small>
            </div>
            <div class="col-5">
              <small class="az-text-small"> Janela de tempo </small>
            </div>
            <div class="col-7 text-right">
              <small class="az-text-small font-bold">
                {{ lineDataEsquerda.labels[0] || '-' }}
                {{
                  lineDataEsquerda.labels.length > 0
                    ? ' a ' +
                        lineDataEsquerda.labels[
                          lineDataEsquerda.labels.length - 1
                        ] || ''
                    : ''
                }}
              </small>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="az-card-bordered h-100">
          <p class="mb-10">
            <strong class="az-ds-card-title"> Perfil de investidor: </strong>
            <small class="az-text-small az-muted font-bold">
              {{ restricoes_simulacao.perfil || 'Desconhecido' }}
            </small>
          </p>
          <div
            v-for="(c, index) in Object.values(compEstr)"
            :key="c.name"
            class="row mb-5 justify-content-center"
          >
            <div
              :style="{
                width: '5px',
                'background-color': c.color,
                'border-radius': '30px',
              }"
            >
            </div>
            <div class="col-3">
              <small class="az-text-small"> {{ toPercent(c.esquerda) }} </small>
            </div>
            <div class="col-5 text-center">
              <small class="az-text-small"> {{ c.name }} </small>
            </div>
            <div class="col-3">
              <v-tooltip bottom disabled>
                <template v-slot:activator="{ on }">
                  <small class="az-text-small" v-on="on">
                    {{ toPercent(c.direita) }}
                  </small>
                </template>
                <span v-if="c.direita - c.esquerda > 0">
                  Participação simulada
                  {{ toPercent(c.direita - c.esquerda) }} maior que a atual
                </span>
                <span v-else-if="c.direita - c.esquerda < 0">
                  Participação simulada
                  {{ toPercent(c.esquerda - c.direita) }} menor que a atual
                </span>
                <span v-else>
                  Participação simulada condizente com a atual
                </span>
              </v-tooltip>
            </div>
            <div
              :style="{
                width: '5px',
                'background-color': c.color,
                'border-radius': '30px',
              }"
            >
            </div>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="az-card-bordered h-100">
          <div class="d-flex mb-10">
            <h2 class="az-ds-card-title"> Backtest simulada </h2>
            <v-spacer />
            <BaseModal
              max-width="80%"
              :destroy-on-close="true"
              height="600px"
              class="d-inline"
            >
              <template v-slot:button>
                <div class="d-flex align-center" @click="abrirModal">
                  <small class="az-text-small az-muted mr-1"> Ampliar </small>
                  <icon-svg name="mdi-fullscreen" :size="16" color="#8E8E8E" />
                </div>
              </template>
              <div>
                <Title title="Backtest simulada" />
                <line-chart
                  ref="rentabilidade2"
                  :chart-data="lineDataDireita"
                  :options="lineOptions"
                  :styles="{ height: '80vh', width: '100%' }"
                >
                </line-chart>
              </div>
            </BaseModal>
          </div>
          <line-chart
            ref="rentabilidade"
            :chart-data="lineDataDireita"
            :options="lineOptions"
          >
          </line-chart>
          <div class="d-flex">
            <v-spacer />
            <v-menu top offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <div class="d-flex align-center" v-bind="attrs" v-on="on">
                  <small class="az-text-small az-muted mr-1">
                    Visualizar benchmarks:
                  </small>
                  <v-btn icon small color="primary">
                    <icon-svg name="mdi-plus" :size="16" color="primary" />
                  </v-btn>
                </div>
              </template>
              <div
                class="bg-white p-5"
                style="
                  border-radius: 6px;
                  width: 200px;
                  max-height: 320px;
                  overflow-y: auto;
                "
              >
                <v-checkbox
                  v-for="bench in BENCHMARKS"
                  :key="bench.id"
                  v-model="benchmarks_selecionados_grafico"
                  :label="bench.nome"
                  :value="bench.id"
                  color="primary"
                  dense
                  hide-details
                  @change="benchmark_graph_changed = true"
                />
              </div>
            </v-menu>
          </div>
          <v-divider class="my-5" />
          <div class="d-flex flex-inline" style="align-items: baseline">
            <h2 class="az-text-primary az-size-14 font-semibold mr-1">
              Estatísticas anualizadas
            </h2>
            <v-btn icon x-small @click="entendaMaisEstatistica">
              <icon-svg
                name="info-circle"
                :size="16"
              />
            </v-btn>
          </div>
          <div class="row">
            <div class="col-3">
              <small class="az-text-small">Rent.</small>
            </div>
            <div class="col-3 text-right">
              <small class="az-text-small font-bold">
                {{
                  toPercent(
                    (estatisticaDireita['backtest-statistics'] || {})
                      .retorno_anualizado * 100 || 0
                  )
                }}
              </small>
            </div>
            <div class="col-3">
              <small class="az-text-small">Rent. Rel.</small>
            </div>
            <div class="col-3 text-right">
              <small class="az-text-small font-bold">
                {{
                  toPercent(
                    (estatisticaDireita['backtest-statistics'] || {})
                      .retorno_anualizado_relativo * 100 || 0
                  )
                }}
              </small>
            </div>
            <div class="col-3">
              <small class="az-text-small">Vol.</small>
            </div>
            <div class="col-3 text-right">
              <small class="az-text-small font-bold">
                {{ toPercent(estatisticaDireita.vol * 100 || 0) }}
              </small>
            </div>
            <div class="col-3">
              <small class="az-text-small">Sharpe</small>
            </div>
            <div class="col-3 text-right">
              <small class="az-text-small font-bold">
                {{ formatNumber(estatisticaDireita.sharp_ratio || 0) }}
              </small>
            </div>
            <div class="col-5">
              <small class="az-text-small">Janela de tempo</small>
            </div>
            <div class="col-7 text-right">
              <small v-if="backtestDireita" class="az-text-small font-bold">
                {{
                  backtestDireita.portfolio
                    ? backtestDireita.portfolio.data[0] || '-'
                    : '-'
                }}
                {{
                  backtestDireita.portfolio &&
                  backtestDireita.portfolio.data.length > 0
                    ? ' a ' +
                        backtestDireita.portfolio.data[
                          backtestDireita.portfolio.data.length - 1
                        ] || ''
                    : ''
                }}
              </small>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6 mt-3">
        <div
          class="az-card-bordered h-100 d-flex flex-column justify-content-center"
        >
          <h2 class="az-ds-card-title mb-10"> Liquidez carteira atual </h2>
          <ShowLiquidez :values="liquidezEsquerda" :size="0" />
        </div>
      </div>
      <div class="col-6 mt-3">
        <div
          class="az-card-bordered h-100 d-flex flex-column justify-content-center"
        >
          <h2 class="az-ds-card-title mb-10"> Liquidez simulada </h2>
          <ShowLiquidez :values="liquidezDireita" :size="0" />
        </div>
      </div>

      <div class="col-6 mt-3">
        <div class="az-card-bordered h-100">
          <div class="d-flex justify-content-between mb-10">
            <div class="d-flex align-center">
              <h2 class="az-ds-card-title">
                {{
                  simulacaoEsquerda.hash
                    ? simulacaoEsquerda.nome_simulacao
                    : 'Carteira atual'
                }}
              </h2>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    x-small
                    class="ml-1"
                    aria-label="Info dos ativos"
                    v-bind="attrs"
                    v-on="on"
                    @click="
                      moreInfo(ativosEsquerda, {
                        title: simulacaoEsquerda.hash
                          ? simulacaoEsquerda.nome_simulacao
                          : 'Carteira atual',
                        subtitle: 'P/L: ' + toMoney(pl_esquerda),
                      })
                    "
                  >
                    <icon-svg
                      name="info-circle"
                      :size="16"
                    />
                  </v-btn>
                </template>
                <span>Info dos ativos</span>
              </v-tooltip>
            </div>
            <div>
              <span class="az-text-small az-muted d-block">P/L:</span>
              <span class="az-text-primary font-bold">
                {{ toMoney(pl_esquerda) }}
              </span>
            </div>
          </div>
          <SimulatorPortfolioTable
            :headers="headerCarteiraSimples"
            :items="ativosEsquerda"
            :group-by="modo"
            :fixed-assets="novosAtivos"
            only-edit-notes
            is-compact
            :max-tags-display="1"
            @save-notes="handleSaveNotes"
            @block-asset="bloquearAtivo"
            @change-asset="trocarAtivo"
            @fix-asset="fixarAtivo"
          />
        </div>
      </div>
      <div class="col-6 mt-3">
        <div class="az-card-bordered h-100">
          <div class="d-flex justify-content-between mb-10">
            <div class="d-flex align-center">
              <h2 class="az-ds-card-title"> Carteira simulada </h2>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    x-small
                    class="ml-1"
                    aria-label="Info dos ativos"
                    v-bind="attrs"
                    v-on="on"
                    @click="
                      moreInfo(ativosDireita, {
                        title: 'Carteira simulada',
                        subtitle: 'P/L: ' + toMoney(pl_direita),
                      })
                    "
                  >
                    <icon-svg
                      name="info-circle"
                      :size="16"
                    />
                  </v-btn>
                </template>
                <span>Info dos ativos</span>
              </v-tooltip>
            </div>
            <div>
              <span class="az-text-small az-muted d-block"> P/L: </span>
              <span class="az-text-primary font-bold">
                {{ toMoney(pl_direita) }}
              </span>
            </div>
          </div>
          <SimulatorPortfolioTable
            :headers="headerCarteiraSimulada"
            :items="ativosDireita"
            :group-by="modo"
            :fixed-assets="novosAtivos"
            only-edit-notes
            is-compact
            :max-tags-display="1"
            @save-notes="handleSaveNotes"
            @block-asset="bloquearAtivo"
            @change-asset="trocarAtivo"
            @fix-asset="fixarAtivo"
          />
        </div>
      </div>
      <div class="col-12">
        <div class="az-card-bordered">
          <div class="d-flex align-center mb-10">
            <h2 class="az-ds-card-title"> Movimentações </h2>
            <v-spacer />
            <div class="text-right">
              <span class="az-text-small az-muted d-block"> Aportes: </span>
              <span class="az-text-primary font-semibold">
                {{ totalAportes }}
              </span>
            </div>
            <div class="ml-10 text-right">
              <span class="az-text-small az-muted d-block"> Resgates: </span>
              <span class="az-text-primary font-semibold">
                {{ totalResgates }}
              </span>
            </div>
          </div>

          <SimulatorOperationsTable
            :headers="headerCarteiraCompleta"
            :items="operacoes"
            :group-by="modo"
            :fixed-assets="novosAtivos"
            @save-notes="handleSaveNotes"
            @fix-asset="fixarAtivo"
          />
        </div>
      </div>

      <v-scale-transition>
        <ButtonAction
          v-if="!simulando && simulacaoDireita.hash_code"
          color="white"
        >
          <div
            v-if="
              simulacaoDireita.simulacao_salva || simulacaoDireita.expire_date
            "
            class="d-flex align-center"
          >
            <v-btn
              color="white"
              tile
              style="height: 70px !important"
              width="200"
              depressed
              @click="toPermanent"
            >
              <icon-svg name="mdi-clock" color="primary" class="mr-3" :size="24" />
              <div class="d-flex flex-column align-start">
                <div v-if="!simulacaoDireita.simulacao_salva">
                  <small class="az-text-small">
                    Simulação será apagada <br />
                    {{ getDistanceDate(simulacaoDireita.expire_date) }}
                  </small>
                  <br />
                  <p class="text-primary mb-0"> Tornar permanente </p>
                </div>
                <div v-else>
                  <small class="az-text-small"> Simulação permanente </small>
                </div>
              </div>
            </v-btn>
            <div class="d-flex align-center mx-2">
              <div style="border-right: 1px solid rgba(0, 0, 0, 0.12); height: 40px"></div>
            </div>
          </div>
          <v-btn
            v-if="!has_changes"
            :loading="loadingPDF"
            color="white"
            tile
            style="height: 70px !important"
            depressed
            @click="openSelectModelPDF"
          >
            <div class="d-flex flex-column align-center">
              <icon-svg name="mdi-file-pdf-box" size="18" color="black" />
              <span class="text-sm mt-1">Exportar</span>
            </div>
          </v-btn>
          <v-btn
            v-if="!has_changes"
            hidden
            color="white"
            tile
            style="height: 70px !important"
            depressed
            :loading="loadingCliente"
            @click="sendClient"
          >
            <div class="d-flex flex-column align-center">
              <icon-svg name="mdi-send" size="18" color="black" />
              <span class="text-sm mt-1">Mobile</span>
            </div>
          </v-btn>
          <v-btn
            v-if="SHOW_WORKSPACE"
            color="white"
            tile
            style="height: 70px !important"
            depressed
            @click="openSendComponent"
          >
            <div class="d-flex flex-column align-center">
              <icon-svg name="mdi-share-variant" size="18" color="black" />
              <span class="text-sm mt-1">Workspace</span>
            </div>
          </v-btn>
          <v-btn
            v-if="restricoes_simulacao.tipo_simulador"
            color="white"
            tile
            style="height: 70px !important"
            depressed
            @click="toRestricoes"
          >
            <div class="d-flex flex-column align-center">
              <icon-svg name="mdi-pencil" size="18" color="black" />
              <span class="text-sm mt-1">Alterar</span>
            </div>
          </v-btn>
          <v-btn
            v-if="has_changes"
            color="white"
            tile
            style="height: 70px !important"
            depressed
            @click="simulateAgain"
          >
            <div class="d-flex flex-column align-center">
              <icon-svg name="mdi-play-circle-outline" size="18" color="black" />
              <span class="text-sm mt-1">Simular</span>
            </div>
          </v-btn>
        </ButtonAction>
      </v-scale-transition>

      <v-scale-transition>
        <div
          v-if="simulando"
          class="v-application"
          style="
            position: fixed;
            bottom: 0;
            width: 40%;
            margin: auto;
            margin-bottom: 20px;
            z-index: 3;
            left: 0;
            right: 0;
          "
        >
          <LoadingStatus
            :loading="simulando"
            :load="simulacaoDireita.load"
            :status="simulacaoDireita.status"
          />
        </div>
      </v-scale-transition>
    </div>
    <ModalPortfolioReviewEditNotes />
    <ModalPesquisaHistorico :bus="busModal" />
    <!-- ...ativosDireita, -> Considerar que os ativos da simulacao nao podem ser fixados -->
    <ModalTrocar
      :bus="busModal"
      :fixados="[...novosAtivos]"
      :pl-total="pl_direita"
    />
    <ModalRestricoes />
    <ModalAmpliarTabela />
  </section>
</template>

<style lang="sass" scoped>
.simulador-comparativo__nome
  cursor: pointer
  transition: opacity 0.15s ease

  &:hover
    opacity: 0.7
</style>
